module.exports = __webpack_public_path__ + "static/img/menu3.788c9714.png";